export default function InvadersIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='55' height='55' viewBox='0 0 24 24'>
      <path
        fill='currentColor'
        d='M7 6H5V4h2v2m10 0h2V4h-2v2m6 6v6h-2v-4h-2v4h-2v-2H7v2H5v-4H3v4H1v-6h2v-2h2V8h2V6h2v2h6V6h2v2h2v2h2v2h2m-8-2v2h2v-2h-2m-8 2h2v-2H7v2m4 6H7v2h4v-2m6 0h-4v2h4v-2Z'
      />
    </svg>
  )
}
